
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabandbusserviceinbalewadi() {



    const cardData =
    {
        keyword: 'Cab and Bus Services in Balewadi',
        heading: 'etravo : Cab and Bus Services in Balewadi',
        headingDescription: 'eTravo delivers reliable Cab and Bus Services in Balewadi, designed to support the daily travel needs of corporate offices, startups, and residential complexes in this fast-developing suburb. From executive cab bookings for meetings and airport transfers to daily staff transportation via well-maintained buses, we offer end-to-end mobility solutions. Our fleet is GPS-enabled and operated by trained chauffeurs, ensuring safety, punctuality, and professionalism. Whether it is for regular employee transport or special corporate events, eTravo provides seamless, efficient, and tailored transport services throughout Balewadi and nearby areas.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fortification in Pune. Though much of it was destroyed in an 1828 fire, the surviving structures and gardens offer a glimpse into its grand past. The site is renowned for its architectural features and is a popular tourist attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Muhammed Shah Aga Khan III, this palace played a significant role during India's freedom movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace now houses a museum and memorials dedicated to Gandhi and his associates."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located approximately 28 km southwest of Pune, Sinhagad Fort is a hill fortress known for the Battle of Sinhagad in 1670. The fort offers panoramic views and is a popular destination for trekking enthusiasts. It houses memorials and remnants of historical significance."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This renowned temple is dedicated to Lord Ganesha and is famous for its rich history and the grand idol adorned with gold. It attracts thousands of devotees, especially during the Ganesh Chaturthi festival."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is carved from a single basalt rock. The temple complex includes a circular Nandi mandapa and is a protected monument under the Archaeological Survey of India."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Situated in Koregaon Park, this meditation center offers a tranquil environment for spiritual growth and wellness. It attracts visitors worldwide seeking meditation and personal development programs."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped garden symbolizes the Indo-Japanese friendship. It features manicured lawns, waterfalls, and a serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of artifacts showcasing India's rich cultural heritage. Exhibits include musical instruments, sculptures, and everyday objects from the 18th and 19th centuries."
    },
    {
      "title": "Koregaon Park",
      "description": "A vibrant neighborhood known for its lush greenery, upscale eateries, and cultural hubs. Koregaon Park is a popular destination for dining, shopping, and experiencing Pune's cosmopolitan lifestyle."
    },
    {
      "title": "Lal Mahal",
      "description": "Originally built in the 17th century, Lal Mahal is historically significant as the childhood residence of Chhatrapati Shivaji Maharaj. The reconstructed palace now serves as a museum showcasing Maratha history."
    }
  ],



 "services": [
  {
    "name": "Cab and Bus Services in Balewadi",
    "description": "eTravo provides professional cab and bus services in Balewadi, Pune, for daily office commutes, business travel, and staff logistics. Covering IT parks and business centers in Balewadi, we ensure safe, reliable, and comfortable transport."
  },
  {
    "name": "Employee Transport Services Balewadi",
    "description": "Streamline staff travel with eTravo’s employee transport services in Balewadi. Our GPS-enabled cabs and buses serve residential clusters around Balewadi with punctual and safe commute solutions for companies of all sizes."
  },
  {
    "name": "Corporate Cab Services Balewadi Pune",
    "description": "Get premium corporate cab services in Balewadi, Pune, with eTravo. Our chauffeur-driven cars are ideal for executive travel, business visits, and daily transport for management-level staff within and around Balewadi."
  },
  {
    "name": "Affordable Employee Transport Balewadi",
    "description": "eTravo offers affordable employee transport in Balewadi, helping businesses optimize travel costs. Cab and bus options, we deliver quality employee transportation while staying budget-conscious."
  },
  {
    "name": "AC Staff Bus Hire Balewadi",
    "description": "Hire air-conditioned staff buses in Balewadi with eTravo for smooth and comfortable group commuting. Ideal for shift-based operations, our AC buses ensure a hassle-free ride experience across Pune’s Balewadi area."
  },
  {
    "name": "Corporate Shuttle Services Balewadi Pune",
    "description": "eTravo’s corporate shuttle services in Balewadi, Pune, offer structured pickup and drop routes for tech parks, BPOs, and MNCs. Designed to reduce late arrivals and absenteeism, our shuttles support employee satisfaction and retention."
  },
  {
    "name": "Car and Bus Rentals for Companies Balewadi",
    "description": "Choose from our fleet of cars and buses for company rentals in Balewadi. eTravo provides flexible plans—daily, weekly, or monthly—for corporate transportation, team outings, and client visits in and around Balewadi."
  },
  {
    "name": "Staff Pickup and Drop Balewadi Pune",
    "description": "Ensure punctuality with eTravo’s staff pickup and drop services in Balewadi, Pune. Our routes are optimized for efficiency, offering reliable service for shift-based industries and corporate offices in the Balewadi region."
  },
  {
    "name": "Customized Mobility Plans Balewadi",
    "description": "eTravo develops customized mobility plans for businesses in Balewadi. Whether you need early morning shifts, late-night drops, or weekend routes, our transport solutions adapt to your workforce needs across Balewadi."
  },
  {
    "name": "Business Meeting Cabs Balewadi",
    "description": "Book professional cabs for business meetings in Balewadi with eTravo. Our executive cab services are ideal for client pickups, conferences, and inter-office travel, ensuring your staff travels in style and on time."
  },
  {
    "name": "Executive Transport Services Balewadi",
    "description": "eTravo’s executive transport services in Balewadi provide high-end travel options for corporate leaders and VIP guests. Our fleet includes premium sedans with professional chauffeurs for seamless and elegant travel experiences."
  },
  {
    "name": "End-to-End Corporate Mobility Balewadi",
    "description": "Get complete corporate mobility solutions in Balewadi with eTravo—from route planning and scheduling to fleet management and tracking. We support your workforce’s daily commute and special events end-to-end."
  },
  {
    "name": "Corporate Commute Services Balewadi Pune",
    "description": "Our corporate commute services in Balewadi, Pune, are designed for maximum efficiency. eTravo helps businesses manage regular staff transport, airport transfers, and inter-office travel with dependable support."
  },
  {
    "name": "Reliable Employee Transport Balewadi",
    "description": "Count on eTravo for reliable employee transport in Balewadi. Our fleet operates with real-time tracking, verified drivers, and safety-first policies, ensuring peace of mind for employers and staff alike."
  },
  {
    "name": "Monthly Cab Rentals for Staff Balewadi",
    "description": "eTravo provides flexible monthly cab rentals for staff in Balewadi. With fixed pricing and guaranteed availability, it’s the ideal solution for companies needing consistent, scheduled employee transport."
  }
],
"tableData": [
  ["Cab and Bus Services in Balewadi", "Employee Transport Services Balewadi"],
  ["Corporate Cab Services Balewadi Pune", "Affordable Employee Transport Balewadi"],
  ["AC Staff Bus Hire Balewadi", "Corporate Shuttle Services Balewadi Pune"],
  ["Car and Bus Rentals for Companies Balewadi", "Staff Pickup and Drop Balewadi Pune"],
  ["Customized Mobility Plans Balewadi", "Business Meeting Cabs Balewadi"],
  ["Executive Transport Services Balewadi", "End-to-End Corporate Mobility Balewadi"],
  ["Corporate Commute Services Balewadi Pune", "Reliable Employee Transport Balewadi"],
  ["Monthly Cab Rentals for Staff Balewadi", ""]
],






"whychoose": [
    {
        "WhyChooseheading": "Reliable Cab and Bus Services in Balewadi",
        "WhyChoosedescription": "Balewadi’s rapid development as a commercial and residential hub demands dependable transport solutions. eTravo provides tailored cab and bus services that cater to IT parks, coworking spaces, and residential societies across Balewadi and nearby areas."
    },
    {
        "WhyChooseheading": "Fleet Options for Every Travel Requirement",
        "WhyChoosedescription": "From compact hatchbacks and comfortable sedans to spacious tempo travellers and AC buses, our Balewadi fleet is equipped for daily staff commutes, business travel, and event transport—offering both convenience and flexibility."
    },
    {
        "WhyChooseheading": "Punctual and Traffic-Aware Transport Services",
        "WhyChoosedescription": "Balewadi often experiences heavy traffic during peak hours. Our drivers and dispatch systems are optimized for timely service, using smart route planning to reduce delays and ensure smooth commutes to and from key locations like Baner, Hinjewadi, and Wakad."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Knowledge",
        "WhyChoosedescription": "Our drivers are not only background-verified and uniformed, but also highly familiar with Balewadi’s roads and access points. Their expertise helps reduce travel time and enhance the overall passenger experience."
    },
    {
        "WhyChooseheading": "Flexible Packages for Businesses and Groups",
        "WhyChoosedescription": "Whether you need long-term shuttle services for your office or a one-time solution for an event, eTravo offers customizable packages in Balewadi—ideal for businesses, housing societies, and educational institutions."
    },
    {
        "WhyChooseheading": "Clear Pricing and Streamlined Billing",
        "WhyChoosedescription": "With transparent pricing and GST-compliant invoicing, eTravo ensures your transport costs in Balewadi are easy to manage. Monthly reports and dedicated account support simplify budgeting and tracking for HR and finance teams."
    },
    {
        "WhyChooseheading": "Hygiene, Safety, and Comfort Guaranteed",
        "WhyChoosedescription": "Every vehicle is regularly sanitized and equipped with essential safety features like seat belts, GPS tracking, first aid kits, and fire extinguishers—ensuring a secure and clean commute every time."
    },
    {
        "WhyChooseheading": "24/7 Monitoring and Customer Support",
        "WhyChoosedescription": "eTravo’s dedicated operations team monitors all rides in real time and offers round-the-clock support to handle scheduling, route changes, and urgent requests—ensuring consistent service quality in Balewadi."
    }
]








































    }

const faqData = [
    [
        {
            question: 'What cab and bus services does eTravo offer in Balewadi?',
            answer: 'eTravo provides comprehensive cab and bus services in Balewadi, including corporate transport, daily employee commutes, event transportation, and executive travel across Pune and beyond.',
        },
        {
            question: 'Are eTravo’s services suitable for companies in Balewadi IT hubs?',
            answer: 'Yes, eTravo caters to companies located in Balewadi’s IT and commercial zones with efficient transport solutions tailored for multiple shifts and diverse corporate needs.',
        },
        {
            question: 'What types of vehicles does eTravo offer in Balewadi?',
            answer: 'Our fleet in Balewadi includes hatchbacks, sedans, SUVs, tempo travellers, and AC buses (13–50 seaters), all selected for comfort, safety, and corporate standards.',
        },
        {
            question: 'Do the cab and bus services in Balewadi include GPS tracking and safety features?',
            answer: 'Absolutely. All vehicles are GPS-tracked in real time and include features like driver ID verification, digital trip logs, and route adherence reports for complete travel transparency.',
        },
        {
            question: 'Is dedicated account management provided for Balewadi-based clients?',
            answer: 'Yes, every corporate client in Balewadi is assigned a dedicated account manager to oversee scheduling, fleet coordination, and service quality on an ongoing basis.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Nikhil Patil',
        designation: 'Admin Executive, Delta Infotech, Balewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s services in Balewadi have been excellent. Their vehicles are always on time, well-maintained, and the staff is responsive to any operational needs.”',
    },
    {
        name: 'Ms. Priya Shah',
        designation: 'HR Coordinator, Orion Systems, Balewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo for our employee transport in Balewadi. The real-time tracking and punctual service have really helped streamline our operations.”',
    },
];













    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab and Bus Services in Balewadi",
  "image": "https://www.etravo.in/images/keyword/cab-bus-balewadi.jpg",
  "description": "Affordable cab and bus services in Balewadi providing employee transport, corporate shuttle services, AC staff bus hire, and customized mobility plans for corporate commute and business needs.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-and-bus-services-in-balewadi"
  }
};





    return (
        <div>

<Helmet>
  <title>Cab and Bus Services in Balewadi | Corporate Employee Transport & Shuttle Solutions | eTravo</title>
  <meta 
    name="description" 
    content="Affordable and reliable cab and bus services in Balewadi by eTravo. Employee transport, corporate shuttle, AC staff bus hire, and monthly cab rentals tailored for business commute." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/14.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabandbusserviceinbalewadi;